import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import wordmark from './images/voidmaw-wordmark.png';

// A transparent header that floats over the page rather than a solid chrome
// band. The wordmark on the left is the way home, so there's no HOME link.
// `pressHref` and `steamHref` are per-game: they only appear on that game's
// pages, never on studio pages.
function Navbar({ pressHref, steamHref, highlightPress = false }) {
  return (
    <nav className={`navbar${highlightPress ? ' navbar-game' : ''}`}>
      <Link to="/" className="navbar-mark" aria-label="Voidmaw home">
        <img src={wordmark} alt="Voidmaw" />
      </Link>

      <div className="navbar-links">
        {steamHref && (
          <a href={steamHref} target="_blank" rel="noopener noreferrer" className="navbar-link">
            Steam
          </a>
        )}
        {pressHref && <a href={pressHref} className={`navbar-link${highlightPress ? ' navbar-press-highlight' : ''}`}>Press</a>}
        <Link to="/contact" className="navbar-link">Contact</Link>
      </div>
    </nav>
  );
}

export default Navbar;
